export default {
    data() {
        return {
            pagenation: {
                list: [],
                pageSize: 6,
                pageNum: 1,
                loadStatus: 'more' // more nomore loading
            }
        };
    },
    computed: {
        local() {
            return this.$store.getters.local;
        },
        i18n() {
            return this.$store.state.language;
        }
    },
    filters: {
        parseDate(val) {
            if (isNaN(val)) return '';
            const date = new Date(val);
            const y = date.getFullYear();
            const m = date.getMonth() + 1;
            const d = date.getDate();
            return `${y}年${m}月${d}日`;
        }
    },
    methods: {
        getLocal(arr, key) {
            // console.log(JSON.stringify(arr));
            if (!Array.isArray(arr)) return '';
            for (const item of arr) {
                if (item.language === this.i18n) {
                    return item[key];
                }
            }
        },
        scrollTop(behavior = 'smooth') {
            window.scrollTo({ top: 0, behavior });
        },
        setPagenation(data) {
            this.pagenation.list = this.pagenation.list.concat(data.data);
            this.pagenation.pageNum++;
            if (data.data.length === this.pagenation.pageSize) {
                this.pagenation.loadStatus = 'more';
            } else {
                this.pagenation.loadStatus = 'nomore';
            }
        },
        resetPagenation() {
            this.pagenation.list = [];
            this.pagenation.pageNum = 1;
            this.pagenation.loadStatus = 'more';
        },
        humanDate(timeStamp) {
            var date = new Date(timeStamp);
            const y = date.getFullYear();
            var m = date.getMonth() + 1;
            var d = date.getDate();
            m = m > 9 ? m : '0' + m;
            d = d > 9 ? d : '0' + d;
            return `${y}-${m}-${d}`;
        },
        i18nImg(i18n, imgName) {
            const img = require(`@/assets/image/${i18n}/${imgName}`);
            return img;
        }
    }
};
